export default __webpack_public_path__ + "static/media/icons-coin-green-32-px.d1c2f111.svg";